import React from 'react';

import moment from 'moment';

import TextButton from 'CommonComponents/TextButton';

import XMarkIcon from 'Assets/icons/xmark.svg';

/**
 * Whether an expense fund request is still open.
 *
 * Compared against `status` (the untranslated 'PENDING'), not `status_label`.
 * See UserRequestListPositionFundApprovalsRow for why the distinction matters.
 */
export const isExpenseFundApprovalPending = (row, pendingStatus) => row.status === pendingStatus;

/**
 * One expense fund request a user raised.
 *
 * Rendered by Home's unified My Requests list. `typeLabel` and `showValue` are
 * optional and additive — see UserRequestListPurchaseRequisitionsRow.
 *
 * The purchase order and its requisition are reached optionally: an expense fund
 * approval that has lost either falls back to the amount.
 */
export default function UserRequestListExpenseFundApprovalsRow({ row, typeLabel, showValue, rowClassName, isPending, onView, onCancel }) {
    const purchaseOrder = row.uncommitted_expenditure?.purchase_order;

    return (
        <tr className={rowClassName}>
            <td className="tw-cursor-pointer inbud-date-cell" onClick={onView}>
                {moment(purchaseOrder?.submission_date || row.created_at).format('YY-MM-DD')}
            </td>
            {!!typeLabel && (
                <td className="tw-cursor-pointer" onClick={onView}>
                    {typeLabel}
                </td>
            )}
            <td className="tw-cursor-pointer" onClick={onView}>
                {purchaseOrder?.purchase_requisition?.title || row.amount_data.totalDifference}
            </td>
            {!!showValue && (
                <td className="tw-cursor-pointer inbud-numeric-cell" onClick={onView}>
                    {row.amount_data.totalDifference}
                </td>
            )}
            <td className="tw-cursor-pointer" onClick={onView}>
                {row.canceled_at ? $t('Canceled') : row.status_label}
            </td>
            <td>
                {isPending(row) && !row.canceled_at && (
                    <TextButton variant="danger" onClick={() => onCancel(row)}>
                        <XMarkIcon className="tw-w-3 tw-h-3" />
                        {$t('Cancel')}
                    </TextButton>
                )}
            </td>
        </tr>
    );
}
